import { useCallback } from "react";
import useDiscountsInfo, { DISCOUNT_INFO_MODES } from "./useDiscountsInfo";
import { roundNumber } from "@helpers/general";
import DISCOUNT_TYPES from "../constants/DiscountTypes";

export default function useApplyLuxeDiscountToProductPrice() {
  const discountsInfo = useDiscountsInfo(DISCOUNT_INFO_MODES.LUXE_ONLY);

  return useCallback(
    (productPrice, productTags, { useHighestDiscount = false, tierDiscountPercent } = {}) => {
      const getTierPercent = (discount) => {
        if (tierDiscountPercent !== undefined) return tierDiscountPercent;
        if (useHighestDiscount) {
          return discount.thresholdResultPercentage[discount.thresholdResultPercentage.length - 1];
        }
        return discount.thresholdResultPercentage[0];
      };

      const finalPrice = discountsInfo.reduce((price, discount) => {
        let isDiscountApplicable = false;
        if (discount.matchType === "include") {
          isDiscountApplicable = productTags.some((tag) => discount.matchTags.includes(tag));
        }
        if (discount.matchType === "exclude") {
          isDiscountApplicable = !productTags.some((tag) => discount.matchTags.includes(tag));
        }

        if (!isDiscountApplicable) {
          return price;
        }
        if (discount.type === DISCOUNT_TYPES.SITEWIDE_PERCENT) {
          return price * (1 - discount.value / 100);
        }
        if (discount.type === DISCOUNT_TYPES.QUANTITY_PERCENT) {
          return price * (1 - getTierPercent(discount) / 100);
        }
        if (discount.type === DISCOUNT_TYPES.AMOUNT_PERCENT) {
          return price * (1 - getTierPercent(discount) / 100);
        }
        if (discount.type === DISCOUNT_TYPES.GIFT_WITH_PURCHASE) {
          return price;
        }
        console.warn(
          "useApplyLuxeDiscountToProductPrice: Unsupported discount type",
          discount.type
        );
        return price;
      }, parseFloat(productPrice));

      return roundNumber(finalPrice);
    },
    [discountsInfo]
  );
}
